// MyComponents/rapidLayerComponents/RapidLayerAnim.js
import React, { useLayoutEffect, useEffect, useState, useRef } from 'react';
import Cursor from './js/cursor';
import Revealer from './js/revealer';
import { preloadImages } from './js/utils';
import './css/base.css';
import { FaLock } from 'react-icons/fa';
// import ProductsPage from "../components/ProductsPage";
// import videoSrc from './homepage.mp4';

const STORAGE_KEY = 'RapidLayerIntroDone';

// Disable browser scroll‐restoration without tripping ESLint
if (
  typeof window !== 'undefined' &&
  window.history &&
  'scrollRestoration' in window.history
) {
  window.history.scrollRestoration = 'manual';
}


const RapidLayerAnimation = () => {
  const [isIntro, setIsIntro] = useState(true); // ✅ Manage "intro" state
  const [isIntroDone, setIsIntroDone] = useState(false);
  const mainRef = useRef(null); // ✅ To access the <main> element
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {

    const navEntries = performance.getEntriesByType?.("navigation") || [];
  const navType    = navEntries[0]?.type ?? performance.navigation?.type;
  if (navType === "reload" || navType === 1 /* TYPE_RELOAD */) {
    // window.scrollTo(0, 0);
    sessionStorage.removeItem(STORAGE_KEY);
  }

    if (sessionStorage.getItem(STORAGE_KEY)) {
      setIsIntro(false);
      setIsIntroDone(true);

      // clean up any loading/scroll locks
      document.body.classList.remove('no-scroll');
      mainRef.current?.classList.remove('intro');

      // fast‑forward the GSAP timeline to its end state
      const revealer = new Revealer();
      revealer.tl.progress(1, false);

      return;
    }

    document.body.classList.add('no-scroll');
    
    preloadImages('.layers__item-img').then(() => {
      document.body.classList.remove('loading');
      const revealer = new Revealer();

      // ✅ Add a timeline callback to remove "intro" class via React state
      revealer.tl.call(() => {
        setIsIntro(false);
        setIsIntroDone(true);
        sessionStorage.setItem(STORAGE_KEY, 'true');
      }, null, 'halfway');

      document.querySelector('.menu__item--current')
              ?.addEventListener('click', () => revealer.reveal());
    });

    const cursorEl = document.querySelector('.cursor');
    if (cursorEl) {
      const cursor = new Cursor(cursorEl);
      document.querySelectorAll('a').forEach(el => {
        el.addEventListener('mouseenter', () => cursor.emit('enter'));
        el.addEventListener('mouseleave', () => cursor.emit('leave'));
      });
    }
  }, []);

  return (
    <>
      <main ref={mainRef} className={isIntro ? 'intro' : ''} id='main'>
        <div className="content">
          <div className="grid">
            <div className="grid__item grid__item--a" style={{ backgroundImage: `url(/img/homepage_12.jpg)` }}></div>
            <div className="grid__item grid__item--b" style={{ backgroundImage: `url(/img/homepage_15.jpg)` }}></div>
            <div className="grid__item grid__item--c" style={{ backgroundImage: `url(/img/homepage_9.png)` }}></div>
            <div className="grid__item grid__item--d" style={{ backgroundImage: `url(/img/homepage_4.jpg)` }}></div>
            <div className="grid__item grid__item--e" style={{ backgroundImage: `url(/img/homepage_11.jpg)` }}></div>
            <div className="grid__item grid__item--f" style={{ backgroundImage: `url(/img/homepage_6.jpg)` }}></div>
          </div>

          <nav className="menu">
            <a className="menu__item" href='/'>
              <h2 className="menu__item-title">Inkmudra</h2>
              <p className="menu__item-subtitle">Click the title to enter!</p>
            </a>
            <a className="menu__item menu__item--current full-mobile-click" href='/' onClick={(e) => { e.preventDefault(); }}>
            
              <h2 className="menu__item-title start">INKMUDRA</h2>
              <p className="menu__item-subtitle">Your Printing Partner</p>
              <p className="after_subtitle">Your Printing Partner</p>
              <p className="after_subtitle second-line">High-Quality Printing Solutions for Every Need</p>
            </a>
            <a className="menu__item" href='/'>
              <h2 className="menu__item-title">Inkmudra</h2>
              <p className="menu__item-subtitle">Hey, Sup!</p>
            </a>
          </nav>
        </div>

        <div className="layers">
          {["homepage_6", "homepage_4","homepage_12", "homepage_9", "homepage_5", "homepage_15", "homepage_11"].map((num) => (
            <div className="layers__item" key={num}>
              <div className="layers__item-img" style={{ backgroundImage: `url(/img/${num}.jpg)` }}></div>
            </div>
          ))}
        </div>
      </main>

      {isIntroDone && (

        <div
                className="bg-success py-2 my-4 d-flex align-items-center justify-content-center fw-bold security"
                style={{ width: '100vw', color: '#dcd6d2'}}
              >
                <FaLock className="me-2" /> Your Files are Secure, After Printing Files will be Deleted
              </div>
      )}

{!isIntroDone && (
  <svg className="cursor" width="220" height="220" viewBox="0 0 220 220">
    <defs>
      <filter id="filter-1" x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox">
        <feTurbulence type="fractalNoise" baseFrequency="0" numOctaves="1" result="warp" />
        <feOffset dx="-30" result="warpOffset" />
        <feDisplacementMap xChannelSelector="R" yChannelSelector="G" scale="30" in="SourceGraphic" in2="warpOffset" />
      </filter>
    </defs>
    <circle className="cursor__inner" cx="110" cy="110" r="60" />
  </svg>
)}

    </>
  );
};

export default RapidLayerAnimation;
